import { Injectable } from '@angular/core';
import { EnvService } from '@core-mkt/services/env/env.service';
import type { SitesDictionary } from 'libs/common/src/lib/accessibility/description-siblingSites.dictionary';
import { brandSites } from 'libs/common/src/lib/accessibility/description-siblingSites.dictionary';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  public brandSites: SitesDictionary[] = brandSites;

  constructor(public env: EnvService) {}

  get siblingSites(): string[] {
    return this.env.get.brandConfig.siblingSites;
  }

  getFullUrl(): string {
    return '';
  }

  getSeoUrl(): string {
    return '';
  }

  getProtocol(): string {
    return '';
  }

  getHost(): string {
    return '';
  }

  getHostname(): string {
    return '';
  }

  getPort(): string {
    return '';
  }

  getPathname(): string {
    return '';
  }

  getQueryParams(): { [key: string]: string } {
    return {};
  }

  getQueryParam(key: string): string | null {
    return null;
  }

  getHash(): string {
    return '';
  }
}
